import { Component, ViewChild, Directive, ElementRef, Input, OnChanges, SimpleChange } from '@angular/core';
import {
  NavController,
  ToastController,
  AlertController,
  Content,
  MenuController,
  Events,
  ModalController
} from 'ionic-angular';
import { OrderConfirmPage } from "../order-confirm/order-confirm";
import { SearchPage } from "../search/search";
import { CustomerWishListPage } from "../customer-wish-list/customer-wish-list";
import { loginUserInfo, MOVESTOCKLOCATION, MOVESTOCKCART } from "../../providers/data";
import { BarcodeScanner } from 'ionic-native';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Api } from "../../providers/api";
import { ApiOffline } from "../../providers/api-offline";
import { IMAGES_BASE_URL, ApplicationVariables } from '../../providers/config';
import { CustomerCarts } from '../../providers/user-cart-provider/user-carts';
import { ItemsPage } from '../items/items';
import { LoginPage } from '../login/login';
import { MyOrderPage } from '../my-order/my-order';
import { Constants } from '../../providers/config';
import 'rxjs/add/operator/map';
import { GVLogger } from '../../services/gv-logger';
import { MsgManager } from '../../providers/msg-manager';
import { ItemPage } from '../item-details/item-details';
import { Storage } from '@ionic/storage';
import { File } from '@ionic-native/file';
import { ThankYouModalPage } from '../thank-you-modal/thank-you-modal';
import { CartManager } from "../../providers/cart-manager";
import { LicenseStatusModelPage } from '../license-status-model/license-status-model';
import { LocationCodeModelPage } from '../location-code-model/location-code-model';
import { LocationsListPage } from '../locations-list/locations-list';
import { MovestockcartManager } from "../../providers/movestockcart-manager";
import { ProductListModelPage } from "../product-list-model/product-list-model";
import { ProductLocationsModelPage } from "../product-locations-model/product-locations-model";
import { MoveProductLocationModelPage } from "../move-product-location-model/move-product-location-model";

@Component({
  selector: 'page-move-stock-cart',
  templateUrl: 'move-stock-cart.html',
})
export class MoveStockCartPage {

  isWebstore = 0;
  isOfflineMode: any = false;

  public constants = Constants;
  public multipleCarts = false;
  public cart: any;
  public TotalPrice: number = 0;
  public TotalPriceBeforeTax: number = 0;
  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
  public barCodeFocus = "Pull product by Scan Code.";
  public locationFocus = "Pull products by location.";
  @ViewChild('barcodeFocus') barCodeFocusInput;
  @ViewChild(Content) content: Content;
  taxPercent = 0; // changed from  0.13
  TAX = 0;
  public locationSelected = 0;
  selectedProductType = -1;
  badInventorySelectedProductType = -2;
  haveTitle: boolean = false;
  cartTitleTemp: string = "";
  orderStatus: number;
  cacheImages: any;
  quantity: any;
  updateButtonStatus = true;
  reference = null;
  productLocation = "";
  productLocationCode = "";
  loggedInUserWarehouse = loginUserInfo.assignedWarehouseName
  referenceStatus = true;
  referenceTypeCheck = true;
  productConditionsList = [{
    productCondition: "All",
    productConditionCode: -1
  }, {
    productCondition: "Good",
    productConditionCode: 0
  },
  {
    productCondition: "Bad",
    productConditionCode: 1
  }];


  items = [];

  resultsAvailable: boolean = false;
  results: string[] = [];
  ignoreNextChange: boolean = false;
  locationPopUpOpenStatus: boolean = false;

  badInventoryOptionSelected = false;
  badProductConditionsList = [];

  productConditionDisabledStatus = false;
  scannedLocation = "";
  private cartRestStatus = false;

  // Add new property for loading state
  isMovingStock: boolean = false;

  constructor(public nav: NavController,
    private stockCartManager: MovestockcartManager,
    public http: Http,
    public api: Api,
    public toastCtrl: ToastController,
    public menuController: MenuController,
    public alertCtrl: AlertController,
    public menu: MenuController,
    public customerCarts: CustomerCarts,
    public events: Events,
    private gVLogger: GVLogger,
    private msgManager: MsgManager,
    private modalController: ModalController,
    private apiOffline: ApiOffline,
    private storage: Storage,
    private file: File,
    private modalCtrl: ModalController,
    private cartManager: CartManager) {
    try {
      if (this.reference.trim() === "") {
        this.reference = null;
      }

    } catch (err) {
      this.gVLogger.log("errrrroeerrrrrr : " + err);

    }

    // this.selectedProductType = 0;

    if (this.reference != "" && this.reference != null) {
      this.referenceStatus = false;
    }


    this.storage.get("cacheImages").then((cache) => {
      this.cacheImages = cache;
    });

    this.isOfflineMode = ApplicationVariables.isOffline;

    if (Constants.isWebstore) {
      this.isWebstore = 1;
    }

    this.cart = MOVESTOCKCART;

    if (MOVESTOCKLOCATION.productsLocation != "" || MOVESTOCKLOCATION.productsLocation != null) {
      this.productLocation = MOVESTOCKLOCATION.productsLocation;
    }
    // this.stockCartManager.removeJunkFromCart();

    this.orderStatus = this.stockCartManager.getOrderStatus();
    this.cartTitleTemp = this.stockCartManager.getOrderTitle();

    this.events.publish("titleChange");

    if (this.cartTitleTemp != "") {
      this.haveTitle = true;
    }

    this.events.subscribe("titleChange", () => {
      this.gVLogger.log(this.stockCartManager.getOrderTitle());
      this.cartTitleTemp = this.stockCartManager.replaceDoublePipe(this.stockCartManager.getOrderTitle());
      if (this.cartTitleTemp == "") {
        this.haveTitle = false;
      } else {
        this.haveTitle = true;
      }
    });

    this.refreshTotalPrice();
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;

    if (!Constants.isWebstore && !ApplicationVariables.isOffline) {
      this.getCustomerCarts(0);
    }

    this.updateButtonStatus = true;

    this.events.subscribe("cartUpdated", () => {
      this.refreshTotalPrice();
    });
  }

  onblurReference() {
    this.items = [];
    // if(this.reference !== null && this.cart.items.length >= 1){
    if (this.cart.items.length >= 1) {
      this.referenceStatus = false;
    }
  }

  onInputChange(event: any) {
    this.items = [];
    let substring = event.target.value;
    if (this.ignoreNextChange) {
      this.ignoreNextChange = false;
      return;
    }



    if (substring.trim() == "") {
      substring = -1;
    }
    this.api.get("products/getReferencNo/" + substring)
      .map(res => res.json())
      .subscribe(data => {
        if (data.status === "200") {
          this.items = [];
          for (let item of data.data) {
            this.items.push(item.referenceNo);
          }

          if (this.items.length > 0) {
            this.resultsAvailable = true;
          } else {
            this.resultsAvailable = false;
          }
        } else {
          this.items = [];
        }

      });
  }

  supplierSelected(selected: string): void {
    this.reference = selected;
    this.items = [];
    this.resultsAvailable = false;
    this.ignoreNextChange = true;

    this.items = [];
    // if(this.reference !== null && this.cart.items.length >= 1){
    if (this.cart.items.length >= 1) {
      this.referenceStatus = false;
    }
  }


  getLocations() {

    // if(this.locationPopUpOpenStatus == false){
    //   this.locationPopUpOpenStatus = true;

    let loc = "";

    loc = "-1";


    // if(loc !== "" && loc !== null){
    this.api.get("products/getLocationsByAdpCustomerId/?searchString=" + loc)
      .map(res => res.json())
      .subscribe(data => {
        if (data.status === "200") {
          let items = [];
          for (let item of data.data) {
            // let loc = item.name + " (" + item.locationCode + ")";
            let loc = { name: item.name, locationCode: item.locationCode }
            items.push(loc);
            this.gVLogger.log("daaaattaaaaa : " + items);
          }

          let model = this.modalController.create(LocationsListPage, { items: items, searchString: loc });
          model.onDidDismiss(data => {
            this.gVLogger.log("data on dismiss : " + data);
            if (data !== "" && data != null) {
              // alert("Dattttaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa " + data )
              this.addFromLocationCode(data.locationCode);
              // this.productLocation = data;
              // this.stockCartManager.setLocation(data);
              // this.referenceStatus = false;
            }
            else {

            }
          });
          model.present();

          this.items = [];
        }

      });

    setTimeout(() => {
      this.locationPopUpOpenStatus = false;
    }, 500)


    // }
    // else{
    //
    // }
  }

  getLocationsOnFocus() {

    if (this.locationPopUpOpenStatus == false) {
      this.locationPopUpOpenStatus = true;

      let loc = "";

      loc = "-1";


      // if(loc !== "" && loc !== null){
      this.api.get("products/getLocationsByAdpCustomerId/?searchString=" + loc)
        .map(res => res.json())
        .subscribe(data => {
          if (data.status === "200") {
            this.items = [];
            for (let item of data.data) {
              // let loc = item.name + " (" + item.locationCode + ")";
              let loc = { name: item.name, locationCode: item.locationCode }
              this.items.push(loc);
              this.gVLogger.log("daaaattaaaaa : " + this.items);
            }

            let model = this.modalController.create(LocationsListPage, { items: this.items, searchString: loc });
            model.onDidDismiss(data => {
              this.gVLogger.log("data on dismiss : " + data);
              if (data !== "" && data != null) {
                this.productLocation = data.name + " (" + data.locationCode + ")";
                this.productLocationCode = data.locationCode;
                this.stockCartManager.setLocation(data.locationCode);
                // this.referenceStatus = false;
              }
              else {
                // this.productLocation = "";
              }
            });
            model.present();

            this.items = [];
          }

        });

      setTimeout(() => {
        this.locationPopUpOpenStatus = false;
      }, 500)


    }
    else {

    }
  }

  search(val) {
    this.gVLogger.log("search called" + val);
  }

  removeFocus() {
    this.gVLogger.log("remove focus called");
  }

  ionViewDidLoad() {

    // setTimeout(() => {

    //   if(!Constants.isWebstore){
    //
    //     this.barCodeFocusInput.setFocus();
    //   }
    // },800); //a least 150ms.

  }

  updatereferenceStatus() {
    this.gVLogger.log("Update reference called");
  }


  checkReferenceTypeOfCartProducts() {
    if (this.stockCartManager.getProductsCount() < 1) {
      this.referenceStatus = true;
    }
    for (let item of this.cart.items) {
      if (item.referenceNumber != "" && this.stockCartManager.getProductsCount() >= 1) {
        this.referenceStatus = false;
        return;
      }
      else {
        this.referenceStatus = true;
      }
    }
  }

  updateProductInCart(product) {
    if (String(product.quantity) != "") {
      if (String(product.quantity).match(/^\d+$/)) {
        this.stockCartManager.updateCartNew(product);
      } else {
        product.quantity = Number(product.quantity);
        this.stockCartManager.updateCartNew(product);
      }
    } else {
      product.quantity = Number(product.quantity);
      this.stockCartManager.updateCartNew(product);
    }
    this.refreshTotalPrice();

  }


  // place order
  buy() {
    if (this.cart.items.length > 0) {
      if (this.locationSelected == 0 || this.locationSelected == undefined) {
        this.msgManager.toastMsg("Please select a shipto location first.");
      } else {

        if (!Constants.isWebstore && this.stockCartManager.getOrderTitle() == "") {

          let prompt = this.alertCtrl.create({
            title: 'Please enter stock location info',
            inputs: [
              {
                name: 'title',
                placeholder: 'Title'
              },
            ],
            buttons: [
              {
                text: 'Cancel',
                handler: data => {
                  //  this.gVLogger.log('Cancel clicked');
                }
              },
              {
                text: 'Confirm',
                handler: data => {
                  //   this.gVLogger.log(data.title);
                  this.stockCartManager.setOrderTitle(data.title);
                  // this.gVLogger.log("cart title on save... : ",this.stockCartManager.getOrderTitle());
                  this.nav.push(OrderConfirmPage, { TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected });
                  // TODO: triger title change event
                  this.events.publish("titleChange");
                }
              }
            ]
          });
          prompt.present();
        } else {
          this.nav.push(OrderConfirmPage, { TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected });
        }
      }
    } else {
      this.msgManager.toastMsg("Please add product(s) to cart first.");
    }
  }


  addFromBarcodeResolver(event) {
    if (ApplicationVariables.isOffline) {
      this.addFromBarCodeOffline(event);
    } else {
      this.addFromBarCode(event);
    }
  }


  addFromBarCodeOffline(event) {
    this.apiOffline.getProductFromBarcode(event.target.value).then((result) => {


      var json = JSON.parse(result.rows.item(0).json);

      this.addProductToCart(json);
      this.scrollBottom();
      this.content.resize();

    });
    setTimeout(() => {
      event.target.value = "";
      event.target.focus();

    }, 50);

  }

  addLocation(event) {
    setTimeout(() => {
      let locationBarCode = event.target.value;
      if (locationBarCode !== "") {
        this.productLocation = locationBarCode;
      }
      else {
        this.productLocation = "";
      }
    }, 400);
  }

  selectAll(event) {
    event.target.select();
  }


  // addFromBarCode(event){
  //   setTimeout(()=>{
  //     let barCode=event.target.value;
  //     if(event.target.value !== ""){
  //
  //       this.api.get("products/getProductByBarcodeWithOutRef/?barcode="+barCode+"&isWebStore="+this.isWebstore)
  //
  //         .map(res => res.json())
  //         .subscribe(data => {
  //
  //           if (data.status == "401") { // check for session out
  //             this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
  //             setTimeout(() => {
  //               event.target.value = "";
  //               event.target.focus();
  //             }, 500)
  //
  //             this.nav.setRoot(LoginPage);
  //           } else if (data.status == 200) {
  //
  //                 data.data.quantity = data.data.totalQuantityShipmentNotice;
  //
  //                   if (data.data.id != 0) {
  //
  //                     this.addProductToCart(data.data);
  //                     this.scrollBottom();
  //                     // setTimeout(()=>{
  //                     event.target.value = "";
  //                     event.target.focus();
  //                     // },500);
  //
  //
  //                   } else if (data.data.status === "0") {
  //
  //                     this.msgManager.toastMsg("The product with Barcode: " + barCode + " has already been shipped!");
  //                     setTimeout(() => {
  //                       event.target.value = "";
  //                       event.target.focus();
  //                     }, 500)
  //
  //                   }
  //                   setTimeout(() => {
  //                     event.target.value = "";
  //                     event.target.focus();
  //                   }, 500)
  //
  //           }else if(data.status == "404"){
  //
  //             this.msgManager.toastMsg("No product found with  Barcode: " + barCode + "!");
  //             setTimeout(()=>{
  //               event.target.value = "";
  //               event.target.focus();
  //             },500)
  //
  //           }
  //         });
  //       setTimeout(()=>{
  //         event.target.value = "";
  //         event.target.focus();
  //       },500);
  //     }
  //   },400);
  //
  //   setTimeout(()=>{
  //     event.target.value = "";
  //     event.target.focus();
  //   },500);
  //   this.scrollBottom();
  // }


  addFromBarCode(event) {
    event.target.value = event.target.value.trim();
    setTimeout(() => {
      let barCode = event.target.value;
      if (event.target.value !== "") {

        let productConditionCode = -1;
        if (this.badInventoryOptionSelected) {
          productConditionCode = this.badInventorySelectedProductType;
        } else {
          productConditionCode = this.selectedProductType;
        }

        this.api.get("products/getProductQuantitiesAcrossLocation/?barcode=" + barCode + "&productConditionCode=" + productConditionCode)

          .map(res => res.json())
          .subscribe(data => {

            if (data.status == "401") { // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
              setTimeout(() => {
                event.target.value = "";
                event.target.focus();
              }, 500)

              this.nav.setRoot(LoginPage);
            } else if (data.status === "200") {

              this.productConditionDisabledStatus = true;

              if (data.data.length <= 0) {
                this.msgManager.toastMsg("No product received with  Barcode: " + barCode + "!");
                setTimeout(() => {
                  event.target.value = "";
                  event.target.focus();
                }, 500)
              }

              // let productLocationsModel = this.modalCtrl.create(ProductListModelPage, { product: data.data, data : data.data }, {cssClass : "productLocationStyle"});
              // productLocationsModel.onDidDismiss(dataFromProductListModel => {
              //   this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductListModel);
              //   if(dataFromProductListModel !== null && dataFromProductListModel !== undefined){
              //     data.data.productInventoryLocationsDTO = [];
              //     data.data.productInventoryLocationsDTO.push(dataFromProductListModel);
              for (let product of data.data) {
                product.productLocationIdWithCode = product.id + product.productInventoryLocationsDTO[0].inventoryLocationById.locationCode + product.productInventoryLocationsDTO[0].productConditionCode;
                for (let loc of product.productInventoryLocationsDTO) {
                  loc.quantityReceived = loc.quantityRemaining;
                }
                this.addProductToCart(product);
                this.scrollBottom();
                event.target.value = "";
                event.target.focus();
              }

              //   }
              // })
              // productLocationsModel.present();


            } else if (data.status == "404") {

              this.msgManager.toastMsg("No product found with  Barcode: " + barCode + "!");
              setTimeout(() => {
                event.target.value = "";
                event.target.focus();
              }, 500)

            }
          });
        setTimeout(() => {
          event.target.value = "";
          event.target.focus();
        }, 500);
      }
    }, 400);

    setTimeout(() => {
      event.target.value = "";
      event.target.focus();
    }, 500);
    this.scrollBottom();
  }


  addFromLocationCode(value) {
    setTimeout(() => {
      let locationCode = value;
      this.scannedLocation = locationCode;
      if (value !== "") {

        let productConditionCode = -1;
        if (this.badInventoryOptionSelected) {
          productConditionCode = this.badInventorySelectedProductType;
        } else {
          productConditionCode = this.selectedProductType;
        }

        this.api.get("products/getProductsByLocationCode/?locationCode=" + locationCode + "&productConditionCode=" + productConditionCode)

          .map(res => res.json())
          .subscribe(data => {

            if (data.status == "401") { // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
              setTimeout(() => {
                value = "";
                // event.target.focus();
              }, 500)

              this.nav.setRoot(LoginPage);
            } else if (data.status === "200") {
              if (data.data.length <= 0) {
                this.msgManager.toastMsg("No product received with  location code: " + locationCode + "!");
                setTimeout(() => {
                  value = "";
                  // event.target.focus();
                }, 500)
              }

              // let productLocationsModel = this.modalCtrl.create(ProductListModelPage, { product: data.data, data : data.data }, {cssClass : "productLocationStyle"});
              // productLocationsModel.onDidDismiss(dataFromProductListModel => {
              //   this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductListModel);
              // if(dataFromProductListModel !== null && dataFromProductListModel !== undefined){
              //   data.data.productInventoryLocationsDTO = [];
              //   data.data.productInventoryLocationsDTO.push(dataFromProductListModel);
              for (let product of data.data) {
                product.productLocationIdWithCode = product.id + product.productInventoryLocationsDTO[0].inventoryLocationById.locationCode + product.productInventoryLocationsDTO[0].productConditionCode;
                for (let loc of product.productInventoryLocationsDTO) {
                  loc.quantityReceived = loc.quantityRemaining;
                }
                this.addProductToCart(product);
                this.scrollBottom();
                value = "";
                // event.target.focus();
              }


              // }
              // })
              // productLocationsModel.present();


            } else if (data.status == "404") {

              this.msgManager.toastMsg("No product found with  Barcode: " + locationCode + "!");
              setTimeout(() => {
                value = "";
                // event.target.focus();
              }, 500)

            }
          });
        setTimeout(() => {
          value = "";
          // event.target.focus();
        }, 500);
      }
    }, 400);

    setTimeout(() => {
      value = "";
      // event.target.focus();
    }, 500);
    this.scrollBottom();
  }
  presentThankYouAlert(title, msg) {
    let thankyouModal = this.modalCtrl.create(ThankYouModalPage, { title: title, message: msg });
    thankyouModal.present();
  }

  presentPaySatusAlert(title, msg) {
    this.gVLogger.log("LicenseStatusModelPage");
    let thankyouModal = this.modalCtrl.create(LicenseStatusModelPage, { title: title, message: msg });
    thankyouModal.present();
  }

  chooseFromLocations(product) {
    this.gVLogger.log("LicenseStatusModelPage" + product);
    let backup = JSON.stringify(product);
    this.gVLogger.log("LicenseStatusModelPageeeee" + this.cart);
    // this.api.get("/products/getLocationAgainstProductIdAndLocationId/" + product.id + "/" + product.productInventoryLocationsDTO[0].inventoryLocationById.id
    // ).map(res => res.json()).subscribe(data => {
    //   this.gVLogger.log("data from /products/getProductsForPickShip : " + data);
    //   if(data.status === "200"){

    let productLocationsModel = this.modalCtrl.create(MoveProductLocationModelPage, { product: backup, orderStatus: this.cart.orderStatus }, { cssClass: "productLocationStyle" });
    productLocationsModel.onDidDismiss(dataFromProductLocationsModel => {
      // this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductLocationsModel);


      if (dataFromProductLocationsModel !== null && dataFromProductLocationsModel !== undefined) {

        this.gVLogger.log("Data from product location model in pickpack list : " + JSON.stringify(dataFromProductLocationsModel));
        product.productInventoryLocationsDTO = dataFromProductLocationsModel;
        // this.totalQuantityOfSelectedProducts();
      }
    })
    productLocationsModel.present();
    // }
    // });

  }

  totalQuantityPlacedOnLocation(product) {
    let totalQuantity = 0;
    for (let loc of product.productInventoryLocationsDTO) {
      // this.gVLogger.log("Quantity TTTTTTTTTTTTTTTT " + loc.quantityRemaining);
      totalQuantity += loc.quantityRemaining;
    }

    return totalQuantity;
  }


  totalQuantityToMoveFromLocation(product) {
    let totalQuantityToMove = 0;
    for (let loc of product.productInventoryLocationsDTO) {
      if (loc.quantityReceived <= 0 && loc.status === 0) {
        totalQuantityToMove += loc.quantityRemaining;
      } else {
        totalQuantityToMove += loc.quantityReceived;
      }
    }

    return totalQuantityToMove;
  }

  checkProductType(type) {
    if (type === 0) {
      return false;
    }
    else {
      return true;
    }
  }


  holdCart() {
    this.updateButtonStatus = false;

    // Check for empty inventory first before showing loader
    if (Number(this.stockCartManager.getProductsCount()) < 1) {
      this.msgManager.toastMsg("Can't save empty list.");
      setTimeout(() => {
        this.updateButtonStatus = true;
      }, 2000)
      return null;
    }

    // Only show loader if we have inventory to move
    this.isMovingStock = true;
    this.gVLogger.log("update button status : " + this.updateButtonStatus);

    let location = this.productLocationCode.trim();

    if (location === "") {
      let locationModel = this.modalCtrl.create(LocationCodeModelPage, { title: "Empty Location!", message: "The location field cannot be left empty. Please enter a valid location." });
      locationModel.present();


      // this.msgManager.toastMsg("Location should not empty!");
      setTimeout(() => {
        this.updateButtonStatus = true;
        this.isMovingStock = false; // Stop loading
      }, 2000)
      return null;
    }

    this.gVLogger.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT" + this.productLocation);
    var body: any = this.stockCartManager.receiveStock(100, this.reference, location); // status 100 for Stock Reading

    // this.gVLogger.log(JSON.stringify(body));
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });

    this.api.getADPPay("feature/getLicenseStatus?customerUUID=" + this.cartManager.getADPCustomerUUID() + "&featureAlias=" + this.constants.Monthly_License_alias + "&consumptionCount=0").map(res => res.json())
      .subscribe(data => {
        if (data.status === 570 || data.status === 571 || data.status === 403) {
          this.presentPaySatusAlert("Failure", data.message);
          this.isMovingStock = false; // Stop loading
        }
        else if (data.status === 200 || data.status === 270) {
          this.api.post("products/moveStockToNewLocation/" + MOVESTOCKLOCATION.productsLocation, JSON.stringify(body), options)
            .map(res => res.json())
            .subscribe(resp => {
              if (resp.status = "200") {
                // Keep loader visible while showing success message
                setTimeout(() => {
                  this.msgManager.toastMsg("Inventory is moved to location: " + MOVESTOCKLOCATION.productsLocation + " successfully!");

                  // Only hide loader after success message is shown
                  setTimeout(() => {
                    this.isMovingStock = false;
                    this.ionViewDidLoad();
                    this.stockCartManager.clearCart();
                    this.refreshTotalPrice();
                    this.stockCartManager.setOrderTitle("");
                    this.events.publish("titleChange");
                    this.stockCartManager.setShipDate("");
                    this.stockCartManager.setOrderMessage("");
                    this.stockCartManager.setOrderId(0);
                    this.getCustomerCarts(0);
                    this.referenceStatus = true;
                    this.stockCartManager.setLocation("");
                    this.updateButtonStatus = true;
                  }, 1000); // Wait 1 second after success message before hiding loader
                }, 100);
              } else if (resp.status == 401) { // check for session out
                this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                this.isMovingStock = false; // Stop loading
                this.nav.setRoot(LoginPage);
              }
              else {
                this.msgManager.toastMsg(this.msgManager.getWentWrongMsg());
                this.isMovingStock = false; // Stop loading
              }
            }, error => {
              this.isMovingStock = false; // Stop loading on error
            });
        }
      });

    this.reference = "";
    this.productLocation = "";
    this.productLocationCode = "";
  }


  // go to search page
  goToSearch() {
    this.menuController.close("testRightMenu");
    this.nav.push(SearchPage);
  }
  goToCustomerWishList() {
    this.nav.push(CustomerWishListPage);
  }

  refreshTotalPrice() {
    this.cart = MOVESTOCKCART;

    let temp: number = 0;
    for (let item of this.cart.items) {
      temp = temp + Number(item.quantity);
    }
    this.TotalPriceBeforeTax = Number(temp.toFixed(2));
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
    //alert(JSON.stringify(this.cart));
  }

  addProductToCart(item) {
    this.stockCartManager.addProductToCart(item);
    this.refreshTotalPrice();
    return true;
  }

  removeProductFromCart(product) {

    this.stockCartManager.removeOneNew(product);

    this.refreshTotalPrice();
  }


  cameraBarcodeScanner() {
    BarcodeScanner.scan().then((barcodeData) => {
      this.msgManager.startLoading();

      if (!barcodeData.cancelled) {

        this.api.get("/products/barcode/" + barcodeData.text + "?isWebStore=" + this.isWebstore)
          .map(res => res.json())
          .subscribe(data => {

            this.msgManager.stopLoading();
            if (data.status == "401") { // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            } else if (data.status == 200) {
              if (data.data.id != 0) {
                this.stockCartManager.addProductToCart(data.data);
              }
            }
          }, (err) => {
            this.msgManager.stopLoading();
          });

      } else {
        this.msgManager.stopLoading();
      }


    }, (err) => {
      this.msgManager.stopLoading();
      //alert("ERROR: "+JSON.stringify(err));
    });

  }

  deleteProductFromCart(product) {

    this.gVLogger.log("detete caled....");
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: "Are you sure you want to delete '" + product.name + "' from the cart?",
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
          }
        },
        {
          text: 'Agree',
          handler: () => {
            this.stockCartManager.deleteProductFromCart(product);
            this.refreshTotalPrice();
            this.checkReferenceTypeOfCartProducts();
          }
        }
      ]
    });
    confirm.present();
  }
  clearCart() {
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: 'You want to clear all the products from cart',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            // this.gVLogger.log('Agree clicked');
            this.stockCartManager.clearCartProducts();
            this.refreshTotalPrice();
          }
        }
      ]
    });
    confirm.present();
  }

  onFocusBarcode(event) {
    event.target.value = "";
    this.barCodeFocus = "Scanner ACTIVE";

  }

  onFocusLocationCode(event) {
    event.target.value = "";
    this.barCodeFocus = "Location Scanner ACTIVE";

  }
  onBlurBarcode(event) {
    event.target.value = "";

    this.barCodeFocus = "Pull product by Scan Code.";
  }


  onFocusLocation(event) {
    event.target.value = "";
    this.barCodeFocus = "Scanner ACTIVE";

  }
  onBlurLocation(event) {
    event.target.value = "";

    this.barCodeFocus = "Pull products by location.";
  }

  activateBarcodeField() {
    //this.gVLogger.log("activateBarcodeField Loaded");
    setTimeout(() => {
      // Keyboard.show() // for android
      this.barCodeFocusInput.setFocus();
    }, 0); //a least 150ms.
  }

  locationSelectedChange(event) {
    //alert(this.locationSelected);
  }

  onChangeSelectedProductType(event) {
    // let value = event.target.value;
    this.gVLogger.log("EEEEEEEEEEEEEEEEEEE " + this.selectedProductType);

    if (this.selectedProductType === 1) {
      this.getLookupBadProductConditions();
      this.badInventoryOptionSelected = true;
    } else {
      this.badInventoryOptionSelected = false;
    }

    if (this.scannedLocation !== "") {

      this.ionViewDidLoad();
      this.stockCartManager.clearCart();



      let productConditionCode = -1;
      if (this.badInventoryOptionSelected) {
        productConditionCode = this.badInventorySelectedProductType;
      } else {
        productConditionCode = this.selectedProductType;
      }

      this.api.get("products/getProductsByLocationCode/?locationCode=" + this.scannedLocation + "&productConditionCode=" + productConditionCode)

        .map(res => res.json())
        .subscribe(data => {

          if (data.status == "401") { // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            setTimeout(() => {
              event.target.value = "";
              event.target.focus();
            }, 500)

            this.nav.setRoot(LoginPage);
          } else if (data.status === "200") {
            if (data.data.length <= 0) {
              this.msgManager.toastMsg("No product received with  location code: " + this.scannedLocation + "!");
              setTimeout(() => {
                event.target.value = "";
                event.target.focus();
              }, 500)
            }

            // let productLocationsModel = this.modalCtrl.create(ProductListModelPage, { product: data.data, data : data.data }, {cssClass : "productLocationStyle"});
            // productLocationsModel.onDidDismiss(dataFromProductListModel => {
            //   this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductListModel);
            // if(dataFromProductListModel !== null && dataFromProductListModel !== undefined){
            //   data.data.productInventoryLocationsDTO = [];
            //   data.data.productInventoryLocationsDTO.push(dataFromProductListModel);
            for (let product of data.data) {
              product.productLocationIdWithCode = product.id + product.productInventoryLocationsDTO[0].inventoryLocationById.locationCode + product.productInventoryLocationsDTO[0].productConditionCode;
              for (let loc of product.productInventoryLocationsDTO) {
                loc.quantityReceived = loc.quantityRemaining;
              }
              this.addProductToCart(product);
              this.scrollBottom();
            }


          } else if (data.status == "404") {

            this.msgManager.toastMsg("No product found with  Barcode: " + this.scannedLocation + "!");
            setTimeout(() => {
              event.target.value = "";
              event.target.focus();
            }, 500)

          }
        });
    }
  }
  onChangeSelectedBadType() {
    if (this.scannedLocation !== "") {

      this.ionViewDidLoad();
      this.stockCartManager.clearCart();



      let productConditionCode = -1;
      if (this.badInventoryOptionSelected) {
        productConditionCode = this.badInventorySelectedProductType;
      } else {
        productConditionCode = this.selectedProductType;
      }

      this.api.get("products/getProductsByLocationCode/?locationCode=" + this.scannedLocation + "&productConditionCode=" + productConditionCode)

        .map(res => res.json())
        .subscribe(data => {

          if (data.status == "401") { // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            setTimeout(() => {
              // event.target.value = "";
              // event.target.focus();
            }, 500)

            this.nav.setRoot(LoginPage);
          } else if (data.status === "200") {
            if (data.data.length <= 0) {
              this.msgManager.toastMsg("No product received with  location code: " + this.scannedLocation + "!");
              setTimeout(() => {
                // event.target.value = "";
                // event.target.focus();
              }, 500)
            }

            // let productLocationsModel = this.modalCtrl.create(ProductListModelPage, { product: data.data, data : data.data }, {cssClass : "productLocationStyle"});
            // productLocationsModel.onDidDismiss(dataFromProductListModel => {
            //   this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductListModel);
            // if(dataFromProductListModel !== null && dataFromProductListModel !== undefined){
            //   data.data.productInventoryLocationsDTO = [];
            //   data.data.productInventoryLocationsDTO.push(dataFromProductListModel);
            for (let product of data.data) {
              product.productLocationIdWithCode = product.id + product.productInventoryLocationsDTO[0].inventoryLocationById.locationCode + product.productInventoryLocationsDTO[0].productConditionCode;
              for (let loc of product.productInventoryLocationsDTO) {
                loc.quantityReceived = loc.quantityRemaining;
              }
              this.addProductToCart(product);
              this.scrollBottom();
              // event.target.value = "";
              // event.target.focus();
            }


            // }
            // })
            // productLocationsModel.present();


          } else if (data.status == "404") {

            this.msgManager.toastMsg("No product found with  Barcode: " + this.scannedLocation + "!");
            setTimeout(() => {
              // event.target.value = "";
              // event.target.focus();
            }, 500)

          }
        });
    }
  }

  getLookupBadProductConditions() {
    this.api.get("lookup/codesByTable?tableName=badProductConditions").map(res => res.json()).subscribe(result => {
      this.gVLogger.log(result);
      if (result.status == "200") {
        let select = {
          code: "-2",
          abbrivation: " ",
          desctiption: "All"
        }

        let resultedArray = [];
        resultedArray.push(select);
        for (let d of result.data) {
          resultedArray.push(d);
        }
        // result.data.push(select);
        // this.badProductConditionsList = result.data;
        this.badProductConditionsList = resultedArray;
      } else if (result.status == "401") { // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }
    });

  }

  imageNotFound(e, item) {
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }

  discardCart() {    // TODO: Check if order contains ID delete on Server else Delete local
    this.stockCartManager.setLocation("");
    if (Number(this.stockCartManager.getProductsCount()) < 1 && this.selectedProductType === -1) {
      this.msgManager.toastMsg("Can't reset empty list.");
      this.productLocation = "";
      this.productLocationCode = "";
      this.referenceStatus = true;
      this.reference = "";
      return null;
      //UD

    }
    else {
      this.menu.close('testRightMenu');
      // alert(this.stockCartManager.getProductsCount());
      let confirm = this.alertCtrl.create({
        title: 'Are you sure?',
        message: 'You want to discard this Cart',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              //  this.gVLogger.log('Disagree clicked');
            }
          },
          {
            text: 'Agree',
            handler: () => {

              this.productConditionDisabledStatus = false;
              this.selectedProductType = -1;
              this.scannedLocation = "";
              this.badInventorySelectedProductType = -2;
              // this.gVLogger.log('Agree clicked');
              this.reference = "";
              this.productLocation = "";
              this.productLocationCode = "";
              this.referenceStatus = true;

              if (this.stockCartManager.getOrderId() == 0) {
                this.gVLogger.log("Local Order");
                this.stockCartManager.clearCartProducts();
                this.stockCartManager.setOrderTitle("");
                this.events.publish("titleChange");
                this.stockCartManager.setOrderId(0);
                this.refreshTotalPrice();
                this.getCustomerCarts(0);

                // this.nav.setRoot(ItemsPage);
              } else {

                let body = "?orderId=" + this.stockCartManager.getOrderId() + "&customerId=" + this.stockCartManager.getSalesManId();

                this.api.post("order/discard" + body, null).map(res => res.json()).subscribe(result => {
                  if (result.status == 200) {
                    this.stockCartManager.clearCartProducts();
                    this.stockCartManager.setOrderTitle("");
                    this.stockCartManager.setOrderId(0);
                    this.refreshTotalPrice();
                    // this.nav.setRoot(ItemsPage);
                    this.getCustomerCarts(0);

                  } else if (result.status == "401") { // check for session out
                    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                    this.nav.setRoot(LoginPage);
                  }
                });

              }

            }
          }
        ]
      });
      confirm.present();
    }
  }



  scrollBottom() {
    setTimeout(() => {
      this.content.scrollToBottom(200);
    }, 400)

  }
  scrollToItem(yOffset) {
    this.content.scrollTo(0, yOffset, 200);
  }

  toggleRignt() {
    this.menu.toggle('testRightMenu');
  }

  getCustomerCarts(startPoint) {
    // let body = {
    //   customerId: this.cartManager.getCustomerID(),
    //   startPoint: startPoint
    // }

    let body = "?customerId=" + this.stockCartManager.getCustomerID() + "&startPoint=" + startPoint;
    this.api.post("order/loadByCustomer" + body, null)
      .map(res => res.json())
      .subscribe(data => {
        if (data.status == 200) {

          this.customerCarts.setCustomerCarts(data.data);
          let cartsOnhold: number = 0;
          for (let cart of data.data) {
            if (cart.orderStatus == 100) {
              cartsOnhold += 1;
            }
          }
          //  this.gVLogger.log(data);
          if (cartsOnhold > 0) {
            this.multipleCarts = true;
          }
        } else if (data.status == "401") { // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        } else {
          this.msgManager.toastMsg(data.message);
        }
      });
  }



  newCart() {

    if (Number(this.stockCartManager.getProductsCount()) < 1) {
      this.msgManager.toastMsg("Cart is already empty");
      return null;
    }
    if (this.stockCartManager.getOrderStatus() == 4) {

      this.stockCartManager.clearCart();
      this.stockCartManager.setOrderTitle("");
      this.stockCartManager.setOrderMessage("");
      this.stockCartManager.setOrderStatus(0);
      this.stockCartManager.setOrderId(0);
      this.refreshTotalPrice();

      // this.nav.setRoot(ItemsPage);

    } else if (this.stockCartManager.getOrderTitle() == "" && this.stockCartManager.getOrderId() == 0) {

      let prompt = this.alertCtrl.create({
        title: 'Please enter stock location info',
        inputs: [
          {
            name: 'location',
            placeholder: 'Name or Location'
          },
          {
            name: 'aisle',
            placeholder: 'Aisle'
          },
          {
            name: 'shelf',
            placeholder: 'Shelf'
          },
          {
            name: 'bin',
            placeholder: 'Bin'
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: data => {
              this.gVLogger.log('Cancel clicked');
            }
          },
          {
            text: 'Save',
            handler: data => {
              this.gVLogger.log(data.title);
              // this.cartManager.setOrderTitle(data.title);
              this.stockCartManager.setOrderTitle(data.location + "||" + data.aisle + "||" + data.shelf + "||" + data.bin);
              //this.cartManager.setOrderId(0);
              var body: any = this.stockCartManager.genrateOrder(100); // status 100 for Stock Reading

              this.gVLogger.log(JSON.stringify(body));
              let headers = new Headers({
                'Content-Type': 'application/json'
              });
              let options = new RequestOptions({
                headers: headers
              });
              this.api.post("order/place", JSON.stringify(body), options)
                .map(res => res.json())
                .subscribe(resp => {
                  if (resp.status = "200") {

                    this.stockCartManager.clearCart();
                    this.stockCartManager.setOrderTitle("");
                    this.events.publish("titleChange");
                    this.stockCartManager.setOrderMessage("");
                    this.stockCartManager.setOrderId(0);
                    this.stockCartManager.setOrderStatus(0);
                    this.refreshTotalPrice();
                    // this.nav.setRoot(ItemsPage);
                    this.getCustomerCarts(0);

                  } else if (resp.status == "401") { // check for session out
                    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                    this.nav.setRoot(LoginPage);
                  }

                }
                  , error => {

                  });

            }
          }
        ]
      });
      prompt.present();



    } else {


      var body: any = this.stockCartManager.genrateOrder(100); // status 100 for Stock reading

      this.gVLogger.log(JSON.stringify(body));
      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });
      this.api.post("order/place", JSON.stringify(body), options)
        .map(res => res.json())
        .subscribe(resp => {
          if (resp.status = "200") {

            this.stockCartManager.clearCart();
            this.stockCartManager.setOrderTitle("");
            this.events.publish("titleChange");
            this.stockCartManager.setOrderMessage("");
            this.stockCartManager.setOrderId(0);
            this.stockCartManager.setOrderStatus(0);
            this.refreshTotalPrice();
            // this.nav.setRoot(ItemsPage);
            this.getCustomerCarts(0);

          } else if (resp.status == "401") { // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }

        }
          , error => {
            this.msgManager.toastMsg("Server down");
          });

    }

  }



  discountCheck(discountPrice) { // if discount price is > 0, return true
    if (Number(discountPrice) > 0) {
      return true;
    } else {
      return false;
    }
  }


  getNumber(val: any) {
    if (isNaN(val)) return 0;
    return +val;
  }

  decimalLengthFixed(num, max) {
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  gotoItemsPage() {
    this.nav.setRoot(ItemsPage);
  }

  gotoOrdersPage() {
    this.nav.setRoot(MyOrderPage);
  }
  logOut() {
    this.nav.setRoot(LoginPage);
  }

  gotoSingleView(product) {
    this.api.get("product/" + product.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if (data.status === "200") {
        product.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, { item: product, "status": "fromReceiveStock" });
  }




  holdCartResolver() {
    this.gVLogger.log("update button status in hold cart " + this.updateButtonStatus);
    this.updateButtonStatus = false;
    this.gVLogger.log("update button status in hold cart " + this.updateButtonStatus);
    if (this.isOfflineMode) {
      this.holdOrderOffline();
    } else {
      this.holdCart();
    }
  }


  holdOrderOffline() {
    if (Number(this.stockCartManager.getProductsCount()) < 1) {
      this.msgManager.toastMsg("Can't Save empty list.");
      return null;
    }


    if (!Constants.isWebstore && this.stockCartManager.getOrderTitle() == "") {
      let prompt = this.alertCtrl.create({
        title: 'Please enter stock location info',
        inputs: [
          {
            name: 'location',
            placeholder: 'Name or Location'
          },
          {
            name: 'aisle',
            placeholder: 'Aisle'
          },
          {
            name: 'shelf',
            placeholder: 'Shelf'
          },
          {
            name: 'bin',
            placeholder: 'Bin'
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: data => {
              //  this.gVLogger.log('Cancel clicked');
            }
          },
          {
            text: 'Save',
            handler: data => {
              this.stockCartManager.setOrderTitle(data.location + "||" + data.aisle + "||" + data.shelf + "||" + data.bin);

              var body: any = this.stockCartManager.genrateOrder(100); // status 100 for Stock reading

              this.apiOffline.insertOrder(JSON.stringify(body))
                .then((data) => {
                  this.stockCartManager.clearCart();
                  this.stockCartManager.setOrderTitle("");
                  this.events.publish("titleChange");
                  this.stockCartManager.setOrderMessage("");
                  this.stockCartManager.setOrderId(0);
                  this.stockCartManager.setOrderStatus(0);
                  this.refreshTotalPrice();
                  // this.nav.setRoot(ItemsPage);
                  this.getCustomerCarts(0);

                })
                .catch(e => this.gVLogger.log(e));

            }
          }
        ]
      });
      prompt.present();
    } else {



      var body: any = this.stockCartManager.genrateOrder(100); // status 100 for Stock readiung

      this.apiOffline.insertOrder(JSON.stringify(body))
        .then((data) => {

          this.stockCartManager.clearCart();
          this.stockCartManager.setOrderTitle("");
          this.stockCartManager.setOrderMessage("");
          this.events.publish("titleChange");
          this.stockCartManager.setOrderId(0);
          this.stockCartManager.setOrderStatus(0);
          this.refreshTotalPrice();
          this.events.publish("titleChange");
          // this.nav.setRoot(ItemsPage);
          this.getCustomerCarts(0);

        })
        .catch(e => this.gVLogger.log(e));




    }


  }

  // makeImageURL(dimensions,item){
  //   return this.stockCartManager.makeImageURL(dimensions,item);
  // }

  makeImageURL(dimensions, item) {
    if (item.productImagesDTO[0].name === "dummy" || item.productImagesDTO[0].name === "dummy") {
      if (this.constants.isWebstore) {
        return this.cartManager.makeNANImageURLFromImage(dimensions);
      }
      else {
        return "./assets/img/dummy-" + dimensions + ".png";
      }
    } else {
      this.gVLogger.log("UUUUUUUURRRRRrl " + this.cartManager.makeImageURL(dimensions, item));
      return this.cartManager.makeImageURL(dimensions, item);
    }
  }


  getCSVFromCARTItems() {

    let temp = this.cart.items.map((o) => { return { id: o.id, Name: o.name, Quantity: o.quantity, barcode: o.barCode } });


    return this.stockCartManager.ConvertToCSV(temp);

  }

  emailCSV() {

    let temp = this.stockCartManager.getOrderTitle().split("||");

    let location = temp[0];
    let aisle = temp[1];
    let shelf = temp[2];
    let bin = temp[3];

    let prompt = this.alertCtrl.create({
      title: 'Please enter stock location info',
      inputs: [
        {
          name: 'location',
          placeholder: 'Name or Location',
          value: location
        },
        {
          name: 'aisle',
          placeholder: 'Aisle',
          value: aisle
        },
        {
          name: 'shelf',
          placeholder: 'Shelf',
          value: shelf
        },
        {
          name: 'bin',
          placeholder: 'Bin',
          value: bin
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            //  this.gVLogger.log('Cancel clicked');
          }
        },
        {
          text: 'Email',
          handler: data => {
            //  this.gVLogger.log(data.title);
            // this.cartManager.setOrderTitle(data.title);
            this.stockCartManager.setOrderTitle(data.location + "||" + data.aisle + "||" + data.shelf + "||" + data.bin);

            var body: any = this.stockCartManager.genrateOrder(100); // status 100 for Stock reading

            let headers = new Headers({
              'Content-Type': 'application/json'
            });
            let options = new RequestOptions({
              headers: headers
            });
            this.api.post("order/place", JSON.stringify(body), options)
              .map(res => res.json())
              .subscribe(resp => {

                this.api.postJazzba('intelliStock/emailService', {
                  email: this.stockCartManager.getSalesPerson().email,
                  subject: this.stockCartManager.replaceDoublePipe(this.stockCartManager.getOrderTitle()),
                  fileText: this.getCSVFromCARTItems(),
                  filename: "StockReading",

                })
                  .map(res => res.json())
                  .subscribe((result) => {
                    if (result.status == 200) {
                      this.stockCartManager.clearCart();
                      this.stockCartManager.setOrderTitle("");
                      this.events.publish("titleChange");
                      this.stockCartManager.setOrderMessage("");
                      this.stockCartManager.setOrderId(0);
                      this.stockCartManager.setOrderStatus(0);
                      this.refreshTotalPrice();

                      this.api.toastMSG(result.message);

                    } else {
                      this.api.toastMSG(result.message);
                    }
                  }, (error) => {
                    this.gVLogger.log(error);
                  })



                // this.nav.setRoot(ItemsPage);
                this.getCustomerCarts(0);

              })

          }
        }
      ]
    });
    prompt.present();

  }

  saveAsCsv() {
    var blob = new Blob([this.getCSVFromCARTItems()]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "newdata.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }


  checkLocationCodeExist() {
    this.updateButtonStatus = false;
    this.gVLogger.log("checkLocationCodeExist called");

    let location = this.productLocation.trim();

    // else{
    // this.api.get("/inventory/checkIfLocationExist?locationCode="+ this.productLocation)
    //   .map(res => res.json())
    //   .subscribe(data => {
    if (location === "") {
      let locationModel = this.modalCtrl.create(LocationCodeModelPage, { title: "Move to location is empty!", message: "The location field cannot be left empty. Please enter a valid location." });
      locationModel.present();
      // this.msgManager.toastMsg("Location should not empty!");
      setTimeout(() => {
        this.updateButtonStatus = true;
      }, 2000)
    }

    else {
      let confirm = this.alertCtrl.create({
        title: ' Are you sure?',
        message: 'You want to move the selected inventory to the location: ' + MOVESTOCKLOCATION.productsLocation,
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              setTimeout(() => {
                this.updateButtonStatus = true;
              }, 2000)
              //  this.gVLogger.log('Disagree clicked');
            }
          },
          {
            text: 'Agree',
            handler: () => {
              setTimeout(() => {
                this.updateButtonStatus = true;
              }, 2000)
              this.holdCartResolver();
            }
          }
        ]
      });
      confirm.present();

    }
    // else if(data.status === "401"){
    //   let locationModel = this.modalCtrl.create(LocationCodeModelPage, {title: "Invalid Location!", message: "The location you entered is not matching any location defined in the system. Please enter a valid location."});
    //   locationModel.present();
    //   setTimeout(() => {
    //     this.updateButtonStatus = true;
    //   }, 2000)
    // }
    // else{
    //   this.gVLogger.log("Status is some thing else than 200 and 401 in location check");
    //   setTimeout(() => {
    //     this.updateButtonStatus = true;
    //   }, 2000)
    // }
    // });
  }
  // }

  // ngOnDestroy() {
  //   if (this.stockCartManager.getProductsCount() > 0) {
  //   let confirm = this.alertCtrl.create({
  //     title: 'Unsaved cart found.',
  //     message: "What would you like to do?",
  //     buttons: [
  //       {
  //         text: 'Go to move stock page',
  //         handler: () => {
  //           this.nav.push(MoveStockCartPage);
  //         }
  //       },
  //       {
  //         text: 'Remove products from move stock',
  //         handler: () => {
  //           this.productLocation = "";
  //           this.stockCartManager.clearCartProducts();
  //         }
  //       }
  //     ]
  //   });
  //   confirm.present();
  // }else {
  //     //do nothing
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/pages/move-stock-cart/move-stock-cart.ts